import { render, staticRenderFns } from "./ShphDoctor.vue?vue&type=template&id=ac532da6&scoped=true&"
import script from "./ShphDoctor.vue?vue&type=script&lang=js&"
export * from "./ShphDoctor.vue?vue&type=script&lang=js&"
import style0 from "./ShphDoctor.vue?vue&type=style&index=0&id=ac532da6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac532da6",
  null
  
)

export default component.exports